import { DropdownList } from "@songtradr-one/components-frontend";
import { Props } from "./UserMenu.Parts";
import { UserMenuContent } from "./user-menu-content/UserMenuContent";

export const UserMenu = ({ anchor, open, onOpenChange, subModules }: Props) => (
  <DropdownList
    anchor={anchor}
    open={open}
    onOpenChange={onOpenChange}
    offset={30}
    minWidth="17.5rem"
  >
    <UserMenuContent onOpenChange={onOpenChange} subModules={subModules} />
  </DropdownList>
);
